import HTTP from "@/_helpers/http";
import { PROFILE__API } from "@/_helpers/urls";
import { PROFILE__MUTATIONS } from "../mutation-types";
import { PROFILE__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

const state = {
  client: null,
  documentInfo: {
    identityVerification: "",
    residenceVerification: "",
    identityVerificationDocuments: [],
    residenceVerificationDocuments: [],
  },
};

const getters = {
  isValidToChangePassword(state) {
    if (
      state.password &&
      state.confirm_password &&
      state.password == state.confirm_password
    )
      return true;
    return false;
  },
};

const mutations = {
  [PROFILE__MUTATIONS.PROFILE](state, client) {
    state.client = client;
  },
  [PROFILE__MUTATIONS.IDENTITYVERIFICATION](state, payload) {
    state.documentInfo.identityVerification = payload;
  },
  [PROFILE__MUTATIONS.RESIDENCEVERIFICATION](state, payload) {
    state.documentInfo.residenceVerification = payload;
  },
  [PROFILE__MUTATIONS.IDENTITYVERIFICATIONDOCUMENTS](state, payload) {
    state.documentInfo.identityVerificationDocuments = payload;
  },
  [PROFILE__MUTATIONS.RESIDENCEVERIFICATIONDOCUMENTS](state, payload) {
    state.documentInfo.residenceVerificationDocuments = payload;
  },
};

const actions = {
  async [PROFILE__ACTIONS.GETPROFILE]({ commit }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).get(PROFILE__API.FETCHPROFILE);
      commit(PROFILE__MUTATIONS.PROFILE, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [PROFILE__ACTIONS.CHANGETHEME]({ dispatch }, data) {
    try {
      const url = `${PROFILE__API.CHANGETHEME}`;
      const response = await HTTP().post(url, data);

      if (response.status === 200) {
        dispatch(PROFILE__ACTIONS.GETPROFILE);
        toast.success(response.data.message);
        return {
          success: true,
          status: 200,
        };
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed To Update Theme");
      return {
        success: false,
        status: error.response?.status || 500,
      };
    }
  },

  async [PROFILE__ACTIONS.CHANGE_PROFILE_URL]({ dispatch, commit }, data) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).post(PROFILE__API.CHANGE_PROFILE_URL, data);
      dispatch(PROFILE__ACTIONS.GETPROFILE);
      toast.success(response?.data?.message);
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message);
    }
  },

  async [PROFILE__ACTIONS.UPDATEPROFILEINFO]({ dispatch, commit }, data) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).post(PROFILE__API.UPDATEPROFILEINFO, data);
      dispatch(PROFILE__ACTIONS.GETPROFILE);
      toast.success(response?.data?.message);
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message);
    }
  },

  async [PROFILE__ACTIONS.FETCHDOCUMENTS]({ commit }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).get(PROFILE__API.FETCHDOCUMENTS);

      if (response.status === 200) {
        const { identityDocument, residenceDocument } = response.data;

        commit(
          PROFILE__MUTATIONS.IDENTITYVERIFICATIONDOCUMENTS,
          identityDocument
        );
        commit(
          PROFILE__MUTATIONS.RESIDENCEVERIFICATIONDOCUMENTS,
          residenceDocument
        );
      } else {
        const errorMessage = response.data.message;
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("An error occurred while fetching documents:", error);
    }
  },

  async [PROFILE__ACTIONS.IDENTITYVERIFICATION]({ commit, dispatch }, data) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).post(PROFILE__API.IDENTITYVERIFICATION, data, {
        timeout: 120000,
      });

      if (response.data.status === 200) {
        commit(
          PROFILE__MUTATIONS.IDENTITYVERIFICATION,
          response.data.documentUrl
        );
        await dispatch(PROFILE__ACTIONS.FETCHDOCUMENTS);
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Upload timed out. Please try again.");
    }
  },

  async [PROFILE__ACTIONS.RESIDENCEVERIFICATION]({ commit, dispatch }, data) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).post(PROFILE__API.RESIDENCEVERIFICATION, data, {
        timeout: 120000,
      });

      if (response.data.status === 200) {
        commit(
          PROFILE__MUTATIONS.RESIDENCEVERIFICATION,
          response.data.documentUrl
        );
        await dispatch(PROFILE__ACTIONS.FETCHDOCUMENTS);
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Upload timed out. Please try again.");
    }
  },

  async [PROFILE__ACTIONS.BECOMEANIB]({ dispatch }) {
    try {
      const response = await HTTP({
        trackProgress: true,
        loadingText: "Processing...",
      }).post(PROFILE__API.BECOMEANIB);
      if (response.status === 200) {
        await dispatch(PROFILE__ACTIONS.GETPROFILE);
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  },

  async [PROFILE__ACTIONS.DELETEDOCUMENT]({ dispatch, commit }, id) {
    try {
      const response = await HTTP().delete(
        `${PROFILE__API.DELETEDOCUMENT}/${id}`
      );

      if (response.status === 200) {
        await dispatch(PROFILE__ACTIONS.DELETEDOCUMENT);
        toast.success(response.data.message || "Deleted successfully");
      }
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  strict: true,
  state,
  getters,
  actions,
  mutations,
};
